import React, { useState } from "react";
import { useEffect } from "react";
import Select from "react-select";
import useAxios from 'hooks/useAxios';

const DrugExclusionNDC = ({ selectedNDC, onSelect }) => {
  const API = useAxios();
  const [ndcName, setNDCName] = useState("");
  const [ndcOpt, setNDCOpt] = useState([]);
  const [ndcLoading, setNdCLoading] = useState(false);

  useEffect(() => {

    if (ndcOpt.length && !selectedNDC) {
      setNDCOpt([]);
    }
  }, [selectedNDC]);

  const handleChangeProvider = async (value) => {
    setNDCName(value);
    if (value.length >= 3) {
      setNdCLoading(true);
      try {
        const result = await API.get(`SBConfig/AutoSearch/NdcListExclusion/${value}`, {
          hasDefaultURL: true,
        });
        if (result?.data?.length > 0) {
          setNDCOpt(result.data);
          setNdCLoading(false);
        } else {
          setNDCOpt([]);
          setNdCLoading(false);
        }
      } catch (error) {
        setNdCLoading(false);
      }
    }
  };

  const onSelectNdc = (provider) => {
    onSelect(provider);
  };

  return (
    <Select
      className="form-field-large inner-shadow-field"
      classNamePrefix="select"
      IndicatorSeparator
      isClearable={true}
      isSearchable={true}
      isLoading={ndcLoading}
      placeholder="Enter any 3 characters"
      name="color"
      options={ndcOpt}
      inputValue={ndcName}
      value={selectedNDC}
      onInputChange={handleChangeProvider}
      onChange={onSelectNdc}
      getOptionLabel={(option) => option.id}
      getOptionValue={(option) => option.id}
      components={{
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
      }}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 99,
        }),
      }}
    />
  );
};

export default DrugExclusionNDC;
